import React from 'react'
import { Box, Element, Heading, Level } from 'react-bulma-components'
import { formatDuration } from '../../utils/date'
import WorkerCounterAdjustForm from './worker-counter-adjust-form'
import { useWorkerCounterQuery } from '../../queries/worker-counters'
import History from '../history/history'
import locales from '../../../../locales/worker-counters'

interface WorkerCounterDetailsProps {
  workerCounterId: string
}

/**
 * Composant pour afficher les détails d'un compteur de travailleur
 * Affiche la valeur actuelle de façon évidente et permet d'ajuster la valeur
 */
const WorkerCounterDetails: React.FC<WorkerCounterDetailsProps> = ({ workerCounterId }) => {
  const { data: workerCounter } = useWorkerCounterQuery(workerCounterId)
  const [showHistory, setShowHistory] = React.useState(false)

  if (!workerCounter) return null

  return (
    <>
      <Level alignItems="center" mb={4}>
        <Level.Side>
          <Heading size={4}>
            {workerCounter.template.name}
            {workerCounter.template.description && (
              <Heading size={6} subtitle>
                {workerCounter.template.description}
              </Heading>
            )}
          </Heading>
        </Level.Side>
        {/*<Level.Side>
          <Tag color={workerCounter.isActive ? 'success' : 'danger'} size="medium">
            {workerCounter.isActive ? 'Actif' : 'Inactif'}
          </Tag>
        </Level.Side>*/}
      </Level>

      {/* Affichage de la valeur actuelle de façon évidente */}
      <Box mb={4}>
        <Element textAlign="center">
          <Heading size={1} textColor="success">
            {formatDuration(workerCounter.currentValue)}
          </Heading>
        </Element>
      </Box>

      {/* Formulaire pour ajuster la valeur */}
      <WorkerCounterAdjustForm workerCounter={workerCounter} />

      {/* Toggle historique */}
      <Element textAlign="right" mb={2}>
        <a
          onClick={() => setShowHistory(v => !v)}
          style={{ cursor: 'pointer' }}
          data-test="worker-counter-history-link"
        >
          {showHistory ? "Masquer l'historique" : "Afficher l'historique"}
        </a>
      </Element>
      {showHistory && <History items={workerCounter.history} locales={locales.history} />}
    </>
  )
}

export default WorkerCounterDetails
